module.exports = __webpack_public_path__ + "b1dfce30b89b8bcf947201930152baee.fbx";